import { useEffect, useRef, useState } from "react";
import { trackEvent } from "@leafly-com/web-utils";
import Link from "next/link";

import useDomainCountryCode from "hooks/useDomainCountryCode";

import SolidArrowIcon from "components/Icons/arrows/SolidArrowIcon";

import { NAV_ITEMS } from "./UserProfileLayout";

const UserProfileMobileNav = ({ currentPage }: { currentPage: string }) => {
  const countryCode = useDomainCountryCode();
  const [isOpen, setOpen] = useState(false);
  const dropdownRef = useRef<HTMLButtonElement>(null);

  useEffect(() => {
    const handleOutsideClick = (e: Event) => {
      if (isOpen && !dropdownRef?.current?.contains(e.target as Node)) {
        setOpen(false);
      }
    };
    document.addEventListener("click", handleOutsideClick, false);
    return () => {
      document.removeEventListener("click", handleOutsideClick, false);
    };
  }, [isOpen]);

  return (
    <button
      className={`dropdown__container w-full p-md bg-leafly-white ${
        isOpen && "dropdown--open"
      }`}
      ref={dropdownRef}
      onClick={() => setOpen(!isOpen)}
      onKeyPress={() => setOpen(!isOpen)}
    >
      <span className="font-bold w-full text-left">{currentPage}</span>
      <span className="dropdown__icon">
        <SolidArrowIcon />
      </span>
      <div className="dropdown__menu">
        {NAV_ITEMS(countryCode)
          .filter((item) => item.name !== currentPage)
          .map((item, i) => (
            <Link
              href={item.url}
              key={`mobile-${i}`}
              className="dropdown__item block"
              onClick={() =>
                trackEvent("Web Profile", item.name, `Select ${item.name}`)
              }
            >
              {item.name}
            </Link>
          ))}
      </div>
    </button>
  );
};

export default UserProfileMobileNav;
